import { Component } from '@angular/core';
import { NavController, Events, IonicPage } from 'ionic-angular';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CrudProvider } from '../../providers/crud/crud';
@IonicPage()
@Component({
  selector: 'page-klmr-dashboard',
  templateUrl: 'klmr-dashboard.html',
})
export class KlmrDashboardPage {
  selectedTab:any = "service"
  serviceList:any = [];
  regoList:any = [];
  constructor(public navCtrl: NavController, public utility: UtiltiyProvider, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
   this.getMetaData();
  }

  segmentChanged(event){
    console.log("event is ",event)

  }


  async getMetaData(){
    this.utiltiy.startLoading();
   this.serviceList = await this.getServiceData();
   this.regoList = await this.getData("get_rego_warning_list");
   this.utiltiy.stopLoading();
  }

  async getServiceData(){
    return this.api.get("/prestart/Mobile_Dashboard/Mobile_Dashboard", false)
    .then((result: any) => {
      console.log("result",result);
      if (result.status) {
        result.result.forEach(element => {
          element.code = 0;
          if(element.vehicle_category == "1" || element.vehicle_category == "4"){
            if(parseFloat(element.current_hrs) >= parseFloat(element.hrs_service_due)){
              element.code = 1;
            }else{
              element.code = 2;
            }
          }
         
          if(element.vehicle_category == "2" || element.vehicle_category == "3"){
            if(parseFloat(element.current_kms) >= parseFloat(element.kms_service_due)){
              element.code = 1;
            }else{
              element.code = 2;
            }
          }
          
        });
        return result.result;
      }else{
       return [];
      }
    }, err => {
      this.utiltiy.stopLoading();
      return [];
    })

  }


  async getData(method){
    let formData: FormData = new FormData();
    formData.append("method_name", method);
    return this.api.post("/prestart/Mobile_Dashboard/Mobile_Dashboard", false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

  }




}



// WEBPACK FOOTER //
// ./src/pages/klmr-dashboard/klmr-dashboard.ts